import {
  Button,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import {
  Container,
  ContainerForm,
  ContainerFormRight,
  Title,
} from "../../styles/index.sty";
import AlertSnack from "../../components/Alert/AlertSnack";
import { useAuth } from "../../context/authContext";
import { useLists } from "../../context/listContext";
import {
  insertProductCategoryData,
  updateProductCategoryData,
} from "../../api/product-categories.api";
import { useEffect } from "react";

export const AddProductCategory = () => {
  const { config2 } = useAuth();
  const {
    fetchProductCategoriesList,
    productCategoriesBarList,
    fetchProductCategoriesBarList,
  } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const prodCat = location?.state?.data;
  const [product_category_bar_id, setProducy_category_bar_id] = useState(
    prodCat?.product_category_bar_id
  );
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState({});
  const [file, setFile] = useState(null);
  useEffect(() => {
    fetchProductCategoriesBarList();
  }, [location]);
  const formik = useFormik({
    initialValues: {
      product_category_name: prodCat?.product_category_name,
      product_category_description: prodCat?.product_category_description,
    },
    onSubmit: async (values) => {
      setLoading(true);
      if (prodCat) {
        const submit = await updateProductCategoryData(
          {
            ...values,
            file,
            image_name: prodCat.product_category_bar_image_name,
            product_category_bar_id,
            product_category_id: prodCat?.product_category_id,
          },
          config2
        );
        setResponse(submit);
        setOpen(true);
        fetchProductCategoriesList();
        if (submit.status === "success") {
          navigate("/product-categories");
        }
      } else {
        const submit = await insertProductCategoryData(
          { ...values, file, product_category_bar_id },
          config2
        );
        setResponse(submit);
        fetchProductCategoriesList();
        setOpen(true);
        if (submit.status === "success") {
          navigate("/product-categories");
        }
      }
    },
  });

  return (
    <>
      <Container>
        <Title variant="h5" className="w-[100%]">
          Enter Product Category Details.
        </Title>
        <ContainerForm>
          {open && (
            <AlertSnack
              open={open}
              setOpen={setOpen}
              response={response}
              setLoading={setLoading}
              route="customers"
            />
          )}

          {loading ? (
            <div className="items-center">
              <BeatLoader color="#36d7b7" />
            </div>
          ) : (
            <div style={{ width: "60%", margin: "auto" }}>
              <FormGroup>
                <InputLabel id="demo-simple-select-label">
                  Product Category Bar:<span className='text-[red]'>** </span>
                </InputLabel>
                <Select
                  id="demo-simple-select"
                  value={product_category_bar_id}
                  style={{ textAlign: "left" }}
                  onChange={(e) => {
                    setProducy_category_bar_id(e.target.value);
                  }}
                >
                  {productCategoriesBarList.map((bar) => {
                    return (
                      <MenuItem
                        value={bar.product_category_bar_id}
                        key={bar.product_category_bar_id}
                      >
                        {bar.product_category_bar_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="product_category_name">
                  Product Category Name:{" "}<span className='text-[red]'>** </span>
                </InputLabel>
                <OutlinedInput
                  name="product_category_name"
                  placeholder="Enter Product Category Name"
                  id="product_category_name"
                  type="text"
                  value={formik.values.product_category_name}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="product_category_description">
                  Product Category Description:{" "}
                </InputLabel>
                <OutlinedInput
                  name="product_category_description"
                  placeholder="Enter Product Category Description"
                  id="product_category_description"
                  type="text"
                  value={formik.values.product_category_description}
                  onChange={formik.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <InputLabel htmlFor="file">Category bar Image:<span className='text-[red]'>** </span> </InputLabel>
                <OutlinedInput
                  name="file"
                  placeholder="Select Image"
                  id="file"
                  type="file"
                  // value={file}
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </FormGroup>
              <div className="flex flex-row justify-between">
                <Button
                  type="button"
                  variant="contained"
                  color="info"
                  onClick={() => navigate("/product-categories")}
                  style={{
                    marginTop: "1rem",
                    width: "48%",
                  }}
                >
                  Back
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  color="info"
                  onClick={formik.handleSubmit}
                  style={{
                    marginTop: "1rem",
                    width: "48%",
                  }}
                >
                  Save & Continue
                </Button>
              </div>
              {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
            </div>
          )}
        </ContainerForm>
        <ContainerFormRight>
          <div className="flex flex-wrap">
            <p className="text-2xl mb-4 w-[100%]">
              <b>Image Preview</b>
            </p>
            <hr />
            {location?.pathname.includes("update") ? (
              <div className="w-[50%] mb-12">
                <p className="text-xl mb-4">
                  <b>Old Image</b>
                </p>
                <img
                  className=" m-auto"
                  src={prodCat?.product_category_image_file}
                  alt={prodCat?.product_category_image_name}
                />
              </div>
            ) : null}
            <div className="w-[50%]">
              <p className="text-xl mb-4">
                <b>New Image</b>
              </p>
              {file ? (
                <img
                  className=" m-auto"
                  src={URL.createObjectURL(file)}
                  alt={prodCat?.product_category_image_name}
                />
              ) : (
                <p>No Image Selected</p>
              )}
            </div>
          </div>
        </ContainerFormRight>
      </Container>
    </>
  );
};
